"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function clearString(unsaveTitle) {
  if (!unsaveTitle) {
    return "";
  }
  let cleanedString = unsaveTitle.replaceAll(/['"]/g, "");
  cleanedString = cleanedString.replaceAll(/[äöüÄÖÜ]/g, function (match) {
    const umlautMap = {
      ä: "ae",
      ö: "oe",
      ü: "ue",
      Ä: "Ae",
      Ö: "Oe",
      Ü: "Ue"
    };
    return umlautMap[match] || match;
  });
  cleanedString = cleanedString.replaceAll(/[^a-zA-Z0-9]/g, "-");
  cleanedString = cleanedString.toLowerCase();
  return cleanedString;
}
var _default = exports.default = clearString;